import { SearchInput } from "@/ui/inputs/Input";
import useTableService from "../useTableServerSide";
import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { formatMoneda } from "@/util/varios";
import { PrimaryButton } from "@/ui/buttons/Button";
import axios from "axios";
import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";
import Footer from "../Footer";
import {
  Card,
  CardContent,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import { Pie, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  LogarithmicScale,
} from "chart.js";
import ModalReporteOrdenPago from "./modalReporteOrdenPago";
import { ActualizarOrdenPago } from "./modalActualizarOrdenPago";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  LogarithmicScale,
);
export default function TablaOrdenesdePagos(props) {
  const op = require("@/modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const idefiscal = localStorage.getItem("idefiscal");
  const espiritu = localStorage.getItem("espiritu");
  const searchTimeoutRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [records, setRecords] = useState([]);
  const [chartLabels, setChartLabels] = useState([]);
  const [chartValues, setChartValues] = useState([]);
  const [backgroundColors, setBackgroundColors] = useState([]);
  const [tipoReporte, setTipoReporte] = useState("");
  const [mostrarImprimir, setMostrarImprimir] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [operacion, setOperacion] = useState(1);
  const [ordenPago, setOrdenPago] = useState();
  const [cuentas, setCuentas] = useState();

  const [montos, setMontos] = useState({
    total: 0,
    ordenPagada: 0,
    ordenXPagar: 0,
    ordenAnulada: 0,
    ordenFinan: 0,
  });
  const [totales, setTotales] = useState({
    total: 0,
    ordenPagada: 0,
    ordenXPagar: 0,
    ordenAnulada: 0,
    ordenFinan: 0,
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [tableState, setTableState] = useState({
    page: 0,
    rowsPerPage: 10,
    search: "",
  });
  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "N° ORDEN",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "PROVEEDOR",
      textAlign: "left",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "FECHA",
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "MONTO",
      textAlign: "center",
    },
    {
      id: "5",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "N° COMPROMISO",
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: " OPCIONES",
      textAlign: "center",
    },
  ];
  const cardsData = [
    {
      title: "Total Ordenes de Pago",
      cantidad: totales.total,
      monto: formatMoneda(
        montos.total.toString().replace(",", "").replace(".", ","),
      ),
      color: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
      icon: "fas fa-cash-register fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
      print: () => {
        setTipoReporte("Total");
        setMostrarImprimir(true);
      },
    },
    {
      title: "Total Ordenes Pagadas",
      cantidad: totales.ordenPagada,
      monto: formatMoneda(
        montos.ordenPagada.toString().replace(",", "").replace(".", ","),
      ),
      color: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      icon: "fas fa-cash-register fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
      print: () => {
        setMostrarImprimir(true);
        setTipoReporte("Pagadas");
      },
    },
    {
      title: "Total Ordenes x Pagar",
      cantidad: totales.ordenXPagar,
      monto: formatMoneda(
        montos.ordenXPagar.toString().replace(",", "").replace(".", ","),
      ),
      color: "linear-gradient(135deg, #0ba360 0%, #3cba92 100%)",
      icon: "fas fa-cash-register fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
      print: () => {
        setMostrarImprimir(true);
        setTipoReporte("Por Pagar");
      },
    },
    {
      title: "Total Ordenes Anuladas",
      cantidad: totales.ordenAnulada,
      monto: formatMoneda(
        montos.ordenAnulada.toString().replace(",", "").replace(".", ","),
      ),
      color: "linear-gradient(135deg, #ff512f 0%, #dd2476 100%)",
      icon: "fas fa-sync fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
      print: () => {
        setMostrarImprimir(true);
        setTipoReporte("Anuladas");
      },
    },
    {
      title: "Total Ordenes Financieras",
      cantidad: totales.ordenFinan,
      monto: formatMoneda(
        montos.ordenFinan.toString().replace(",", "").replace(".", ","),
      ),
      color: "linear-gradient(135deg, #f66e53ff 0%, #d1709cff 100%)",
      icon: "fas fa-sync fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
    },
  ];
  const generateColors = (count) => {
    const colorsPalette = [
      "#3498DB",
      "#2ECC71",
      "#F39C12",
      "#9B59B6",
      "#E74C3C",
      "#1ABC9C",
      "#E67E22",
      "#95A5A6",
      "#34495E",
      "#16A085",
      "#27AE60",
      "#2980B9",
      "#8E44AD",
      "#2C3E50",
      "#D35400",
      "#C0392B",
      "#BDC3C7",
      "#7F8C8D",
      "#F1C40F",
      "#E67E22",
    ];
    return Array.from(
      { length: count },
      (_, i) => colorsPalette[i % colorsPalette.length],
    );
  };
  const chartData = {
    labels: chartLabels,
    datasets: [
      {
        label: "",
        data: chartValues,
        backgroundColor: backgroundColors,
        borderColor: "#ffffff",
        borderWidth: 2,
      },
    ],
  };
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: "rgba(0,0,0,0.8)",
        padding: 10,
        cornerRadius: 4,
        callbacks: {
          label: function (context) {
            const label = context.label || "";
            const value = context.raw || 0;
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            return `${label}: ${value}`;
          },
        },
      },
    },
  };
  const tableCallbacks = {
    onPageChange: (newPage) =>
      setTableState((prev) => ({ ...prev, page: newPage })),
    onRowsPerPageChange: (newLimit) =>
      setTableState((prev) => ({ ...prev, rowsPerPage: newLimit, page: 0 })),
  };
  const { TblContainer, TblHead, TblPagination } = useTableService(
    totalRecords,
    headCells,
    false,
    tableCallbacks,
  );
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    if (value.length === 0)
      return setTableState((prev) => ({ ...prev, search: "", page: 0 }));
    if (value.length < 3) return;
    searchTimeoutRef.current = setTimeout(
      () => setTableState((prev) => ({ ...prev, search: value, page: 0 })),
      500,
    );
  };
  const buscarRegistros = () => {
    setCuentas();
    setOrdenPago();
    setLoading(true);
    const params = {
      page: tableState.page,
      limit: tableState.rowsPerPage,
      search: tableState.search,
      orden: espiritu === 2 ? "idordenpago" : "numordenpago",
      idEfiscal: idefiscal,
    };
    const endpoint = `${op.conexion}/api/administracion/buscar-ordenes-pago-con-compromiso`;
    const controller = new AbortController();
    axios
      .get(endpoint, {
        params,
        signal: controller.signal,
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          const { rows, count, totales, cantidades, grafica } = response.data;
          setRecords(rows);
          setTotalRecords(count);
          setMontos({
            total: totales.total_monto || 0,
            ordenPagada: totales.total_monto_pagada || 0,
            ordenAnulada: totales.total_monto_reversadas || 0,
            ordenXPagar: totales.total_monto_por_pagada || 0,
            ordenFinan: totales.total_monto_financiero || 0,
          });
          setTotales({
            total: cantidades.total_cantidad || 0,
            ordenPagada: cantidades.total_cantidad_pagada || 0,
            ordenAnulada: cantidades.total_cantidad_reversadas || 0,
            ordenXPagar: cantidades.total_cantidad_por_pagada || 0,
            ordenFinan: cantidades.total_cantidad_financiero || 0,
          });
          if (grafica && grafica.length > 0) {
            setChartLabels(grafica.map((e) => e.label));
            setChartValues(grafica.map((e) => e.value));
            setBackgroundColors(generateColors(grafica.length));
          } else {
            setChartLabels([]);
            setChartValues([]);
            setBackgroundColors([]);
          }
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) return;
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al conectar con el servidor",
          icono: "error",
        });
      })
      .finally(() => setLoading(false));

    return () => controller.abort();
  };
  const buscarOrdenesPago = async ({ numordenpago }) => {
    setLoading(true);

    try {
      const resOrdenPago = await axios.get(
        `${op.conexion}/api/administracion/seleccionarordenpago?idefi=${idefiscal}&&idordenp=${numordenpago}&espiritu=${espiritu}&norden=true`,
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      const dataOrden = resOrdenPago.data;
      setOrdenPago(dataOrden[0]);
      setCuentas(dataOrden);
      setShowModal(true);
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto:
          error.response?.data?.message ||
          "Error al cargar la información del proveedor",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const cleanup = buscarRegistros();
    return () => {
      if (cleanup) cleanup();
    };
  }, [tableState]);

  return (
    <div
      className="container-fluid p-4"
      style={{ backgroundColor: "#f8f9fa", height: "90vh" }}
    >
      <div className="row g-3 mb-4">
        {cardsData.map((card, index) => (
          <div
            key={index}
            style={{ borderRadius: 4 }}
            className="col-12 col-sm-4 col-xl"
          >
            <div
              className="card h-100 border-0 rounded-4 shadow-sm position-relative overflow-hidden"
              style={{
                background: card.color,
                color: "white",
                transition: "transform 0.3s, box-shadow 0.3s",
                borderRadius: 15,
                cursor: "pointer",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 15px 40px rgba(0,0,0,0.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.1)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: -20,
                  right: -20,
                  width: 100,
                  height: 100,
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.1)",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: -30,
                  left: -30,
                  width: 150,
                  height: 150,
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.05)",
                }}
              ></div>

              <div className="card-body p-4 m-0">
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <h5
                    className="text-uppercase fw-extrabold mb-0"
                    style={{
                      letterSpacing: "1px",
                      fontSize: "1.1rem",
                      fontWeight: "800",
                    }}
                  >
                    {card.title}
                  </h5>
                  {card.print ? (
                    <div
                      style={{
                        marginTop: "-5px",
                        marginRight: "-10px",
                        cursor: "pointer",
                        position: "relative",
                        zIndex: 10,
                      }}
                    >
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          card.print();
                        }}
                        className="btn btn-sm btn-light rounded-circle shadow-sm"
                        style={{
                          width: "35px",
                          height: "35px",
                          border: "none",
                        }}
                      >
                        <i className="fas fa-print text-dark" />
                      </button>
                    </div>
                  ) : (
                    <i className={`${card.icon} fs-4 opacity-75`}></i>
                  )}
                </div>
                <div className="d-flex flex-column gap-2">
                  <div className="d-flex align-items-center">
                    <span
                      className="small fw-bold opacity-75 text-uppercase"
                      style={{ fontSize: "0.75rem", width: "70px" }}
                    >
                      Cantidad:
                    </span>
                    <span
                      className="fw-bold"
                      style={{ lineHeight: "1", fontSize: "1rem" }}
                    >
                      {card.cantidad}
                    </span>
                  </div>
                  <div className="d-flex align-items-center">
                    <span
                      className="small fw-bold opacity-75 text-uppercase"
                      style={{ fontSize: "0.75rem", width: "70px" }}
                    >
                      Monto:
                    </span>
                    <span
                      className="fw-bold"
                      style={{ lineHeight: "1", fontSize: "1rem" }}
                    >
                      {card.monto}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="row g-4">
        <div className="col-7">
          <div
            className="card shadow-sm border-0"
            style={{ borderRadius: "15px" }}
          >
            <div className="card-header azulGradiant text-white d-flex justify-content-between">
              <h5 className="mb-0 fw-bold text-uppercase">Ordenes de Pago</h5>
              <a
                type="button"
                className="text-light fw-bold fs-6"
                style={{ cursor: "pointer" }}
              >
                <i className="fas fa-times ms-2" />
              </a>
            </div>
            <div className="card-body p-0 m-0">
              <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between align-items-start">
                <div className="col-4 m-0 p-0 position-relative">
                  <SearchInput
                    className="search-input pe-4"
                    value={searchInput}
                    onChange={handleSearch}
                  />
                </div>
                <div className="col-auto mx-2 p-0">
                  <PrimaryButton
                    icon="fa-plus m-0 p-0"
                    onClick={() => {
                      setOperacion(1);
                      setShowModal(true);
                    }}
                  />
                </div>
              </div>
              <section className="col-12 m-0 p-0">
                <TblContainer>
                  <TblHead />
                  <tbody>
                    {records &&
                      records.map((item, index) => (
                        <tr key={index} style={{ padding: "0" }}>
                          <td
                            className="align-baseline"
                            style={{ textAlign: "center", width: "100px" }}
                          >
                            {item.numordenpago}
                          </td>
                          <td
                            className="align-baseline"
                            style={{ textAlign: "left", width: "auto" }}
                          >
                            {item.razonsocial}
                          </td>
                          <td
                            className="align-baseline"
                            style={{ textAlign: "center", width: "50px" }}
                          >
                            {moment.utc(item.fecha).format("DD/MM/YYYY")}
                          </td>
                          <td
                            className="align-baseline"
                            style={{ textAlign: "center", width: "30px" }}
                          >
                            {formatMoneda(
                              item.montoordenpago
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                            )}
                          </td>
                          <td
                            className="align-baseline"
                            style={{ textAlign: "center", width: "120px" }}
                          >
                            {item.idcompromiso}
                          </td>
                          <td
                            className="align-baseline"
                            style={{ textAlign: "center", width: "150px" }}
                          >
                            <button
                              onClick={() => {
                                setOperacion(4);
                                buscarOrdenesPago({
                                  numordenpago: item.numordenpago,
                                });
                              }}
                              className="btn btn-sm mx-1 btn-info rounded-circle"
                              title="Consultar Orden de Pago"
                            >
                              <i className="fas fa-eye"></i>
                            </button>
                            <button
                              onClick={() => {
                                if (
                                  item.conceptoorden !== null &&
                                  item.tipo === 2
                                ) {
                                  setMensaje({
                                    mostrar: true,
                                    titulo: "Informacion.",
                                    texto:
                                      "La orden de pago es de fondo de tercero",
                                    icono: "informacion",
                                  });
                                } else if (item.reversado > 0) {
                                  setMensaje({
                                    mostrar: true,
                                    titulo: "Informacion.",
                                    texto: "La Orden de Pago ya fue Reversada",
                                    icono: "informacion",
                                  });
                                } else if (
                                  item.status === 1 &&
                                  item.tipo !== 23 &&
                                  item.tipo !== 24
                                ) {
                                  setMensaje({
                                    mostrar: true,
                                    titulo: "Informacion.",
                                    texto: "La Orden de Pago ya fue Pagada",
                                    icono: "informacion",
                                  });
                                } else {
                                  setOperacion(2);
                                  buscarOrdenesPago({
                                    numordenpago: item.numordenpago,
                                  });
                                }
                              }}
                              className="btn btn-sm mx-1 btn-success rounded-pill"
                              title="Reversar Orden de Pago"
                            >
                              <i className="fas fa-sync-alt"></i>
                            </button>
                            <button
                              onClick={() => {
                                if (item.reversado === 0) {
                                  setMensaje({
                                    mostrar: true,
                                    titulo: "Informacion.",
                                    texto:
                                      "La orden de pago no ha sido Reversada",
                                    icono: "informacion",
                                  });
                                } else if (
                                  item.status === 1 &&
                                  item.tipo !== 23 &&
                                  item.tipo !== 24
                                ) {
                                  setMensaje({
                                    mostrar: true,
                                    titulo: "Informacion.",
                                    texto: "La Orden de Pago ya fue Pagada",
                                    icono: "informacion",
                                  });
                                } else {
                                  setOperacion(3);
                                  buscarOrdenesPago({
                                    numordenpago: item.numordenpago,
                                  });
                                }
                              }}
                              className="btn btn-sm mx-1 btn-danger rounded-circle"
                              title="Eliminar Orden de Pago"
                            >
                              <i className="fa fa-trash-alt"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </TblContainer>
                <TblPagination />
              </section>
            </div>
          </div>
        </div>
        <div className="col-5">
          <Card
            className="my-2"
            sx={{
              borderRadius: 4,
              boxShadow: 3,
              flex: 1,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CardContent
              sx={{
                p: 2,
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
              <Typography
                variant="subtitle1"
                fontWeight="bold"
                align="center"
                mb={1}
                color="text.secondary"
                style={{ textTransform: "uppercase" }}
              >
                Ordenes de Pagos
              </Typography>
              <Box
                sx={{
                  flex: 1,
                  position: "relative",
                  width: "100%",
                  minHeight: "180px",
                }}
              >
                <Bar
                  data={{
                    labels: [
                      `Total Ordenes: ${parseInt(totales.total) || 0}`,
                      `Pagadas: ${parseInt(totales.ordenPagada) || 0}`,
                      `Por Pagar: ${parseInt(totales.ordenXPagar) || 0}`,
                    ],
                    datasets: [
                      {
                        label: "Cantidad",
                        data: [
                          parseInt(montos.total) || 0,
                          parseInt(montos.ordenPagada) || 0,
                          parseInt(montos.ordenXPagar) || 0,
                        ],
                        backgroundColor: [
                          "rgba(30, 60, 114, 0.8)",
                          "rgba(102, 126, 234, 0.8)",
                          "rgba(11, 163, 96, 0.8)",
                        ],
                        borderColor: [
                          "rgba(30, 60, 114, 1)",
                          "rgba(102, 126, 234, 1)",
                          "rgba(11, 163, 96, 1)",
                        ],
                        borderWidth: 1,
                        borderRadius: 6,
                      },
                    ],
                  }}
                  options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                      legend: { display: false },
                      tooltip: {
                        backgroundColor: "rgba(0,0,0,0.8)",
                        padding: 10,
                        cornerRadius: 4,
                        callbacks: {
                          label: function (context) {
                            return `Cantidad: ${context.raw}`;
                          },
                        },
                      },
                    },
                    scales: {
                      x: {
                        ticks: { font: { size: 10 }, maxRotation: 30 },
                        grid: { display: false },
                      },
                      y: {
                        type: "logarithmic",
                        beginAtZero: true,
                        ticks: {
                          padding: 10,
                          font: { size: 12 },
                          callback: function (value) {
                            return formatMoneda(
                              value.toString().replace(".", ","),
                            );
                          },
                        },
                        grid: { color: "rgba(0,0,0,0.05)" },
                      },
                    },
                  }}
                />
              </Box>
            </CardContent>
          </Card>
          <Card
            className="my-2"
            sx={{
              borderRadius: 4,
              boxShadow: 3,
              flex: 1,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CardContent
              sx={{
                p: 2,
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
              <Typography
                variant="subtitle1"
                fontWeight="bold"
                align="center"
                mb={2}
                color="text.secondary"
                sx={{ textTransform: "uppercase" }}
              >
                total ordenes de pagos x tipos
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  flex: 1,
                  gap: 4,
                  minHeight: 0,
                  maxWidth: "100%",
                  margin: "0 auto",
                  width: "100%",
                }}
              >
                {chartLabels.length > 0 && (
                  <Box
                    sx={{
                      flex: 1,
                      overflowY: "auto",
                      maxHeight: "100%",
                      pr: 1,
                    }}
                  >
                    <List dense sx={{ py: 0 }}>
                      {chartLabels.map((label, index) => {
                        const cleanLabel = label.trim();
                        return (
                          <React.Fragment key={cleanLabel}>
                            <ListItem
                              disableGutters
                              sx={{ py: 0.5 }}
                              secondaryAction={
                                <Typography
                                  variant="caption"
                                  fontWeight="bold"
                                  color="text.primary"
                                >
                                  {chartValues[index]}
                                </Typography>
                              }
                            >
                              <Box
                                sx={{
                                  width: 10,
                                  height: 10,
                                  borderRadius: "50%",
                                  backgroundColor: backgroundColors[index],
                                  mr: 1,
                                  flexShrink: 0,
                                }}
                              />
                              <ListItemText
                                style={{ textTransform: "uppercase" }}
                                primaryTypographyProps={{
                                  variant: "caption",
                                  noWrap: true,
                                  sx: { fontSize: "10px", width: "100%" },
                                }}
                                primary={cleanLabel}
                              />
                            </ListItem>
                            {index < chartLabels.length - 1 && (
                              <Divider component="li" />
                            )}
                          </React.Fragment>
                        );
                      })}
                    </List>
                  </Box>
                )}
                <Box
                  sx={{
                    flex: 1.5,
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    maxHeight: "250px",
                  }}
                >
                  {chartLabels.length > 0 ? (
                    <Pie data={chartData} options={chartOptions} />
                  ) : (
                    <Typography variant="body2" color="text.secondary">
                      No hay datos para mostrar
                    </Typography>
                  )}
                </Box>
              </Box>
            </CardContent>
          </Card>
        </div>
      </div>
      <ModalReporteOrdenPago
        show={mostrarImprimir}
        cancelar={() => setMostrarImprimir(false)}
        tipo={tipoReporte}
      />
      <ActualizarOrdenPago
        show={showModal}
        onHideCancelar={() => setShowModal(false)}
        onHideRenderizar={() => {
          setShowModal(false);
          buscarRegistros();
        }}
        cuentas={cuentas}
        ordenp={ordenPago}
        norden={true}
        operacion={operacion}
        titulo={
          operacion === 4
            ? "Consultar Orden Pago"
            : operacion === 2
              ? "Reversar Orden Pago"
              : operacion === 1
                ? "Incluir Orden Pago"
                : "Eliminar Orden Pago"
        }
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <Dimmer active={loading} inverted />
      <Footer />
    </div>
  );
}
